import { Component, OnChanges, OnInit } from '@angular/core';
import { Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: '',
  template: '',
})
export class AgentReferenceHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  public onAddAgentReferenceDetails(event) {
    // this.service.addAgentReferenceDetails();
  }
}
